
export default function AboutHeroSection() {
  return (
    <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      {/* 背景图片 */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ed1258b210316bf35e718de8eed055c3.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* 内容容器 */}
      <div className="relative z-10 w-full min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-[15%] py-8">
        <div className="w-full max-w-6xl text-center text-white space-y-4 sm:space-y-6 lg:space-y-8">
          {/* 核心理念 */}
          <div className="bg-black/30 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-10 border border-[#cc9966]/30 mx-auto max-w-5xl">
            <h2 className="text-base sm:text-lg lg:text-2xl font-bold text-[#cc9966] mb-4 sm:mb-6 lg:mb-8">
              以透明化体系重构年份茶行业生态
            </h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
              <div className="text-center space-y-2 sm:space-y-3 lg:space-y-4">
                <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-[#cc9966]">透明化体系</h3>
                <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                  全程可视化管理，让每一片茶叶的来源和品质都有据可查
                </p>
              </div>

              <div className="text-center space-y-2 sm:space-y-3 lg:space-y-4">
                <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-[#cc9966]">数据化标准</h3>
                <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                  建立科学的年份茶评价体系，用数据说话，用标准服务
                </p>
              </div>

              <div className="text-center space-y-2 sm:space-y-3 lg:space-y-4">
                <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-[#cc9966]">可视化体验</h3>
                <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                  创新的数字化体验方式，让茶友更直观地了解年份茶价值
                </p>
              </div>
            </div>
          </div>

          {/* 使命愿景 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 lg:p-8 border border-[#cc9966]/30">
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-[#cc9966] mb-3 sm:mb-4">我们的使命</h3>
              <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                成为新一代年份茶的标准制定者与引领者，让每一位茶友都能品味到真正的年份茶精髓
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 lg:p-8 border border-[#cc9966]/30">
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-[#cc9966] mb-3 sm:mb-4">我们的愿景</h3>
              <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                打造全球最具影响力的年份茶品牌，传承中华茶文化，服务全球茶友
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 滚动提示 */}
      <div className="absolute bottom-4 sm:bottom-6 lg:bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}
